import { supabase } from '@/integrations/supabase/client';

const UNCONFIGURED_TIMEZONE_VALUES = new Set(['', 'UTC+00:00']);

export const isTimezoneConfigured = (timezone?: string | null): boolean => {
  if (!timezone) return false;
  return !UNCONFIGURED_TIMEZONE_VALUES.has(timezone.trim());
};

export const getClientTimezoneStatus = async (userId: string): Promise<{
  timezone: string | null;
  isConfigured: boolean;
}> => {
  try {
    const { data } = await supabase
      .from('clients')
      .select('timezone')
      .eq('id', userId)
      .maybeSingle();

    const timezone = data?.timezone ?? null;
    return {
      timezone,
      isConfigured: isTimezoneConfigured(timezone)
    };
  } catch (error) {
    console.error('Failed to check client timezone status:', error);
    return {
      timezone: null,
      isConfigured: false
    };
  }
};
